import React from 'react';
import { useVorgangLockContext } from '@/features/vorgangLocking/VorgangLockProvider';
import { ActionHints } from './ActionHints';
import { AuthenticationWarning } from './AuthenticationWarning';
import { EditActions } from './EditActions';
import { LockActions } from './LockActions';
import { RestoreAction } from './RestoreAction';

interface VorgangActionsProps {
  lockActionsDisabled?: boolean;
  isValid: boolean;
  retryDisabledReason?: string | null;
  deleteDisabledReason: string | null;
  hasRunningAbarbeitung: boolean;
  canSave: boolean;
  canZurueckstellen: boolean;
  istAktuelleAbarbeitung: boolean;
  isDeleted: boolean;
  actionLoading:
    | 'retry'
    | 'delete'
    | 'save'
    | 'lock'
    | 'unlock'
    | 'restore'
    | 'zurueckstellen'
    | null;
  onRetry: () => void;
  onSave: () => void;
  onDelete: () => void;
  onRestore: () => void;
  onZurueckstellen: (kommentar: string) => void;
  isUserAuthenticated: boolean;
  showRetry?: boolean;
  archiveRetry?: boolean;
}

export const VorgangActions: React.FC<VorgangActionsProps> = ({
  lockActionsDisabled = false,
  isValid,
  retryDisabledReason,
  deleteDisabledReason,
  hasRunningAbarbeitung,
  canSave,
  canZurueckstellen,
  istAktuelleAbarbeitung,
  isDeleted,
  actionLoading,
  onRetry,
  onSave,
  onDelete,
  onRestore,
  onZurueckstellen,
  isUserAuthenticated,
  showRetry,
  archiveRetry,
}) => {
  const {
    isLockedByCurrentUser,
    isLockedByOtherUser,
    lockVorgang,
    unlockVorgang,
  } = useVorgangLockContext();

  return (
    <div
      className={`bg-white border border-table-border rounded-lg p-6 ${isDeleted ? 'opacity-60' : ''}`}
    >
      <h2 className="text-lg font-semibold text-text-primary mb-4">Aktionen</h2>

      <div className="flex flex-wrap gap-3">
        {isDeleted ? (
          <RestoreAction onRestore={onRestore} actionLoading={actionLoading} />
        ) : (
          <>
            <LockActions
              isLockedByCurrentUser={isLockedByCurrentUser}
              isLockedByOtherUser={isLockedByOtherUser}
              disabled={lockActionsDisabled}
              onLock={lockVorgang}
              onUnlock={unlockVorgang}
              actionLoading={actionLoading}
            />

            {isLockedByCurrentUser && (
              <EditActions
                hasRunningAbarbeitung={hasRunningAbarbeitung}
                isValid={isValid}
                retryDisabledReason={retryDisabledReason}
                deleteDisabledReason={deleteDisabledReason}
                canSave={canSave}
                canZurueckstellen={canZurueckstellen}
                istAktuelleAbarbeitung={istAktuelleAbarbeitung}
                isUserAuthenticated={isUserAuthenticated}
                actionLoading={actionLoading}
                onRetry={onRetry}
                showRetry={showRetry}
                archiveRetry={archiveRetry}
                onSave={onSave}
                onDelete={onDelete}
                onZurueckstellen={onZurueckstellen}
              />
            )}
          </>
        )}
      </div>

      <AuthenticationWarning isUserAuthenticated={isUserAuthenticated} />
      <ActionHints />
    </div>
  );
};
